const isValidUrl = urlString => {
    var urlPattern = new RegExp('^(https?:\\/\\/)?' + // validate protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
    return !!urlPattern.test(urlString);
}

var cntrlIsPressed = false;

document.onkeydown = function (event) {
    if (event.which == "17")
        cntrlIsPressed = true;
}

document.onkeyup = function () {
    cntrlIsPressed = false;
}

window.oncontextmenu = function (event) {
    try {
        if (event.target.classList.contains("shortcopy")) {
            let start = window.getSelection().baseOffset;
            let end = window.getSelection().focusOffset;
            let val = event.target.textContent.trim();
            if (start != end) {
                val = window.getSelection().baseNode.textContent.substring(start, end);
            } else if (event.target.nodeName == "A" && isValidUrl(event.target.href)) {
                val = event.target.href;
            } else if (event.target.nodeName == "INPUT" || event.target.nodeName == "TEXTAREA") {
                val = event.target.value;
            }
            navigator.clipboard.writeText(val);
            event.preventDefault();
        } else if (event.target.classList.contains("shortpaste")) {
            let val = event.target.textContent.trim();
            if (event.target.nodeName == "INPUT" || event.target.nodeName == "TEXTAREA") {
                navigator.clipboard.readText()
                    .then(
                        cliptext => {
                            event.target.focus();
                            event.target.value = '';
                            window.document.execCommand('insertText', false, cliptext);
                        },
                        err => console.log(err)
                    );
                event.preventDefault();
            }
        } else if (event.target.classList.contains("leadPaste")) {
            let val = event.target.textContent.trim();
            if (event.target.nodeName == "INPUT" || event.target.nodeName == "TEXTAREA" || event.target.nodeName == "SELECT") {
                navigator.clipboard.readText()
                    .then(
                        cliptext => {
                            if (cntrlIsPressed) {
                                let subpart = cliptext.split("\n");
                                let inputBlocks = {
                                    "Name of the Applicant as per PAN": "ApplicantName",
                                    "Applicant Firstname": "ApplicantFirstName",
                                    "Applicant Lastname": "ApplicantLastName",
                                    "PAN No": "PANNumber",
                                    "DOB": "DateOfBirth",
                                    "Contact No": "ContactNo",
                                    "Alternate phone No": "AlternateNo",
                                    "Email": "Email",
                                    "Loan Value": "LoanAmount",
                                    "Loan scheme": "LoanSchema",
                                    "Category": "Category",
                                    "In hand monthly salary": "Salary",
                                    "Name of company": "CompanyName",
                                    "Address as per Aadhar with pin code": "Address",
                                    "Pin code": "PinCode",
                                    "House own/rented": "House",
                                    "Name of the Student": "Student",
                                    "Student Firstname": "StudentFirstName",
                                    "Student Lastname": "StudentLastName",
                                    "Age": "Age",
                                    "Relationship with Applicant": "Relationship"
                                };
                                let data = {};
                                for (let t in subpart) {
                                    let item = subpart[t];
                                    console.log(item);
                                    for (let i in inputBlocks) {
                                        let pattern = new RegExp(i, "i");
                                        if (pattern.test(item)) {
                                            let vals = item.split("-");
                                            if (vals.length) {
                                                vals.shift();
                                                data[inputBlocks[i]] = (vals.join("-")).trim();
                                            } else {
                                                data[inputBlocks[i]] = item;
                                            }
                                        }
                                    }
                                }
                                window.leadData = data;
                                event.target.focus();
                                for (let field in window.leadData) {
                                    if (event.target.classList.contains(field)) {
                                        if (field == "Relationship") {
                                            window.leadData[field] = window.leadData[field].toUpperCase();
                                        }
                                        if (event.target.nodeName == "SELECT") {
                                            event.target.value = window.leadData[field];
                                        } else {
                                            setTimeout( function(){ 
                                                event.target.value = '';
                                                window.document.execCommand('insertText', false, window.leadData[field]);
                                            },100);
                                        }
                                        event.preventDefault();
                                    }
                                }
                            }
                        },
                        err => console.log(err)
                    );
                if (window.leadData) {
                    event.target.focus();
                    for (let field in window.leadData) {
                        if (event.target.classList.contains(field)) {
                            if (field == "Relationship")
                                window.leadData[field] = window.leadData[field].toUpperCase();
                            if (event.target.nodeName == "SELECT") {
                                event.target.value = window.leadData[field];
                            } else {
                                setTimeout( function(){ 
                                    event.target.value = '';
                                    window.document.execCommand('insertText', false, window.leadData[field]);
                                },100);
                            }
                            event.preventDefault();
                        }
                    }
                }
            }
        }
    } catch (e) {
        // Do Nothing Here
    }
};

/** TO DISABLE SCREEN CAPTURE **/
document.addEventListener('keyup', (e) => {
    if (e.key == 'PrintScreen') {
        navigator.clipboard.writeText('');
        //alert('Screenshots disabled!');
    }
});

/** TO DISABLE PRINTS WHIT CTRL+P **/
document.addEventListener('keydown', (e) => {
    if (e.ctrlKey && e.key == 'p') {
        //alert('This section is not allowed to print or export to PDF');
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
});

window.onerror = function () {
    return true;
}